const ORGANIZATION_NAME_MAX_LENGTH = 100;

export const deriveOrganizationName = (
  displayName: string | null,
  email: string,
): string => {
  const owner = displayName?.trim() || email.split('@')[0] || 'My';
  return `${owner}'s Organization`.slice(0, ORGANIZATION_NAME_MAX_LENGTH);
};
